/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsMoveHorizontal = createReactComponent(
  "arrows-move-horizontal",
  "IconArrowsMoveHorizontal",
  [
    ["path", { d: "M18 9l3 3l-3 3", key: "svg-0" }],
    ["path", { d: "M15 12h6", key: "svg-1" }],
    ["path", { d: "M6 9l-3 3l3 3", key: "svg-2" }],
    ["path", { d: "M3 12h6", key: "svg-3" }]
  ]
);

export { IconArrowsMoveHorizontal as default };
//# sourceMappingURL=IconArrowsMoveHorizontal.js.map
